/**
 *
 * Login
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { FormattedMessage } from "react-intl";
import { compose } from "redux";
import LoginForm from "forms/login/";
import SchedulePickup from "containers/ScheduleAPickup";
import Register from "containers/Register/";

import { Container, Row } from "reactstrap";
import { Redirect, Route, Switch } from "react-router-dom";
import Login from "containers/Login";
import ForgotPassword from "containers/ForgotPassword";
import PublicSchedule from "./PublicSchedule";

/* eslint-disable react/prefer-stateless-function */
export class Public extends React.PureComponent {
  render() {
    return (
      <div>
        <Helmet>
          <title>Login</title>
          <meta name="description" content="Description of Login" />
        </Helmet>
        <Switch>
          <Route path="/schedule" component={PublicSchedule} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/forgot_password" component={ForgotPassword} />
          <Route exact path="/create_account" component={Register} />
          <Redirect to="/login" />
        </Switch>
      </div>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(Public);
